import { MethodSummary } from "../models/methodSummary";
import { Params } from "../models/params";

export class MethodServiceSwift{

    public getSGConnectEdgeMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
        new MethodSummary("class func",
        "addObserver",
        "Registers an observer or multiple observers for the bluetooth connectivity status.",
        new Params(["(SGBLEConnectionState,SGError?)", "String?"],                       //parameter type
        ["Observer that triggers on bluetooth connectivity status changes", "Optional key that is used to register/unregister the observer"],    //parameter description
        ["onStateChange","withName"]),                                   //parameter name
        ""
        ),
        new MethodSummary("class func",
        "removeObserver",
        "Removes a previously registered observer",
        new Params(["String"],
        ["Key of the previously registered observer"],
        ["withName"]),
        ""
        ),
        new MethodSummary("class func",
        "removeAllObservers",
        "Removes all previously registered observers",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("class func",
        "purchaseChips",
        "Automatically scans, connects, and then initiates a purchase chips transaction. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["String","String", "UInt32", "onTransactionComplete: @escaping (SGError?) -> Void"],
        ["Account number of the Patron", "Patron's name", "Amount to be transfered in cents", "Transfer status callback"],
        ["accountNumber", "name", "amount", "callback"]),
        ""
        ),
        new MethodSummary("class func",
        "sellChips",
        "Automatically scans, connects, and then initiates a chips sale transaction. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["String","String", "UInt32", "onTransactionComplete: @escaping (SGError?) -> Void"],
        ["Account number of the Patron", "Patron's name", "Amount to be transfered in cents", "Transfer status callback"],
        ["accountNumber", "name", "amount", "callback"]),
        ""
        ),
        new MethodSummary("class func",
        "acceptTransfer",
        "Automatically scans, connects, and then approves a supervisor initiated fund transfer. Can check the callback or the registered SGTransferObserver for status.",
        new Params(["String","String", "onTransactionComplete: @escaping (SGError?) -> Void"],
        ["Account number of the Patron", "Patron's name", "Transfer status callback"],
        ["accountNumber", "name", "callback"]),
        ""
        ),
        new MethodSummary("class func Bool",
        "isSupported",
        "Checks for BLE Support on this device",
        new Params([],
        [],
        []),
        "Checks for BLE Support on this device"
        ),
        new MethodSummary("class func",
        "registerLogger",
        "Callback contains any logs that the framework may be outputting",
        new Params(["SGLoggerDelegate"],
        ["Triggers when framework outputs any logs"],
        ["logger"]),
        ""
        ),
        new MethodSummary("class func",
        "setLogLevel",
        "Filter out below a specified log level.",
        new Params(["SGLogLevel"],
        ["Specify the log level.  i.e ERROR to only get error logs. WARN to only get error and warning logs"],
        ["level"]),
        ""
        ),
        new MethodSummary("static void",
        "SetConnectionRange",
        "Sets the signal strength range to establish a connection to the Gaming Machine, and to disconnect from it.",
        new Params(["UInt8?","UInt8?"],
        ["The value at or below which the mobile can connect to the Gaming Machine. Value must be between 20 and 70.",
        "The value at or beyond which the mobile will warn the player about being far from the Gaming Machine and would disconnect if the player does not return within 10 secs. Value must be greater than connectRSSI and not greater than 100."],
        ["connectRSSI","disconnectRSSI"]),
        ""
        )
      ]
      return methods;
    }

    public getSGBLEConnectMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("class func",
            "addObserver",
            "Registers an observer or multiple observers for the bluetooth connectivity status.",
            new Params(["(SGBLEConnectionState,SGError?)", "String?"],                       //parameter type
            ["Observer that triggers on bluetooth connectivity status changes", "Optional key that is used to register/unregister the observer"],    //parameter description
            ["onStateChange","withName"]),                                   //parameter name
            ""
            ),
            new MethodSummary("class func",
            "addObserver",
            "Registers an observer for the Player session status",
            new Params(["(SGPlayerSessionState, SGError?)","String?"],
            ["Observer that triggers on bluetooth state change", "Optional key that is used to register/unregister the observer"],
            ["onStateChange","withName"]),
            ""
            ),
            new MethodSummary("class func",
            "addObserver",
            "Registers an observer that fires when the state of the user proximity changes",
            new Params(["(SGDeviceProximityState, SGError?)","String?"],
            ["Observer that triggers on proximity state change", "Optional key that is used to register/unregister the observer"],
            ["onStateChange","withName"]),
            ""
            ),
            new MethodSummary("class func",
            "addObserver",
            "Registers an observer or multiple observers for the player profile updates.",
            new Params(["(SGPlayerProfileState, SGError?)","String?"],
            ["Observer that triggers player profile updates", "Optional key that is used to register/unregister the observer"],
            ["onStateChange","withName"]),
            ""
            ),
            new MethodSummary("class func",
            "removeObserver",
            "Removes a previously registered observer",
            new Params(["String"],
            ["Key of the previously registered observer"],
            ["withName"]),
            ""
            ),
            new MethodSummary("class func",
            "removeAllObservers",
            "Removes all previously registered observers",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("class func",
            "createSession",
            "Automatically scans, connects, and then starts a session with the gaming machine. Check player-session and ble-status observable for status.",
            new Params(["android.app.Activity","String"],
            ["Context", "User card number"],
            ["activity", "cardNumber"]),
            ""
            ),
            new MethodSummary("class func",
            "endSession",
            "Sends a command to the gaming machine to end the user's session. Check player-session and ble-status observable for status.",
            new Params([],
            [],
            []),
            ""
            ),
            new MethodSummary("class func Bool?",
            "isPrimaryIdentificationRequired",
            "Checks to see if a primary form of identification is required from the Player for transferring funds.",
            new Params([],
            [],
            []),
            "Returns nil if it is called before `SGPlayerProfileState` goes to `pinSettingAvailable`"
            ),
            new MethodSummary("class func Bool?",
            "isFundsTransferSupported",
            "Checks if Funds Transfer is supported by the Electronic Gaming Machine",
            new Params([],
            [],
            []),
            "Returns nil if it is called before `SGPlayerProfileState` goes to `fundTransferSettingAvailable`"
            ),
            new MethodSummary("class func SGBalance?",
            "getLastCashout",
            "Gets the last cashout for this player from a previous Gaming Machine.",
            new Params([],
            [],
            []),
            "Returns SGBalance if available, or null if it is called before a valid session is created."
            ),
            new MethodSummary("class func",
            "getBalances",
            "Retrieves the balances for all accounts that are active for the player",
            new Params(["([SGBalance],SGError?)"],
            ["Callback that fires when balance is available."],
            ["onBalanceAvailable"]),
            ""
            ),
            new MethodSummary("class func",
            "transferAmount",
            "Transfer a given amount in a particular disposition from a source account to a destination account",
            new Params(["UInt32","SGAccountType","SGAccountType","SGDisposition","String?", "String?", "(SGError?)"],
            ["ammount in cents","source of type 'SGAccountType'","destination of type 'SGAccountType'","funds of type 'SGDisposition'","Optional primary identifier e.g CMS Pin", "An optional secondary identifier","Callback that fires when fund transfer has finished."],
            ["cents","source","destination","disposition","primaryIdentifier","secondaryIdentifier","onTransferComplete"]),
            ""
            ),
            new MethodSummary("class func Bool",
            "isSupported",
            "Checks for BLE Support on this device",
            new Params([],
            [],
            []),
            "Checks for BLE Support on this device"
            ),
            new MethodSummary("class func",
            "registerLogger",
            "Callback contains any logs that the framework may be outputting",
            new Params(["SGLoggerDelegate"],
            ["Triggers when framework outputs any logs"],
            ["logger"]),
            ""
            ),
            new MethodSummary("class func",
            "setLogLevel",
            "Filter out below a specified log level.",
            new Params(["SGLogLevel"],
            ["Specify the log level.  i.e ERROR to only get error logs. WARN to only get error and warning logs"],
            ["level"]),
            ""
            ),
            new MethodSummary("class func",
            "enable",
            "Enables an SG feature",
            new Params(["SGFeature"],
            ["Can pass in multiple features at once by using OR operator e.g SGFeature.SECURITY ^ SGFeature.OTHER"],
            ["feature"]),
            ""
            ),
            new MethodSummary("class func",
            "disable",
            "Disables an SG feature.",
            new Params(["SGFeature"],
            ["Can pass in multiple features at once by using OR operator e.g SGFeature.SECURITY ^ SGFeature.OTHER"],
            ["feature"]),
            ""
            )
          ]
        return methods;
    }

    public getSGLogCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("Void",
            "log",
            "Fires when app logs a message",
            new Params(
              ["String","SGLogLevel","String"],
              ["The importance level of the log","The log message", "The class that fired the log"],
              ["message","level","caller"]),
            ""
            )
          ]

          return methods;
    }


    public getSGBLEStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("Void",
            "onStateChange:",
            "Fires when bluetooth changes state",
            new Params(
              ["SGBLEConnectionState","SGError?"],
              ["The current bluetooth state","Object that holds the error type, a localized description, and stack trace if available."],
              ["state","error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGSessionStatusCallBackMethods():MethodSummary[]{
        var methods:MethodSummary[] = [
            new MethodSummary("void",
            "onStateChange:",
            "Fires when user session changes state",
            new Params(
              ["SGPlayerSessionState","SGError?"],
              ["The current user session state","Object that holds the error type, a localized description, and stack trace if available."],
              ["state","error"]),
            ""
            )
          ]

          return methods;
    }

    public getSGProxStatusCallBackMethods():MethodSummary[]{
      var methods:MethodSummary[] = [
          new MethodSummary("Void",
          "onStateChange:",
          "Fires when device goes in our out of range",
          new Params(
            ["SGDeviceProximityState","SGError?"],
            ["The current posiiton of the device","Object that holds the error type, a localized description, and stack trace if available."],
            ["state","error"]),
          ""
          )
        ]

        return methods;
  }

  public getSGPlayerProfileCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("Void",
        "onStateChange:",
        "Fires when player profile settings come through",
        new Params(
          ["SGPlayerProfileState","SGError?"],
          ["The current player profile state","Object that holds the error type, a localized description, and stack trace if available."],
          ["state","error"]),
        ""
        )
      ]

      return methods;
}

  public getSGPlayerBalanceCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("Void",
        "onBalanceAvailable:",
        "Fires when the gaming machine replies with available balances",
        new Params(
          ["SGBalance[]","SGError?"],
          ["An array of current player balance objects. Contains amount and disposition information","Object that holds the error type, a localized description, and stack trace if available."],
          ["balances","error"]),
        ""
        )
      ]

      return methods;
}

  public getSGFundTransferCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onTransferComplete: ",
        "Fires when the gaming machine completes fund transfer",
        new Params(
          ["(SGError?)"],
          ["Object that holds the error type, a localized description, and stack trace if available.", "If the error object is nil, the transfer was completed succesfully."],
          []),
        ""
        )
      ]

      return methods;
  }

  public getSGFundTransferEdgeCallbackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onTransferComplete: ",
        "Triggers when the payment device completes fund transfer",
        new Params(
          ["(SGError?)"],
          ["Object that holds the error type, a localized description, and stack trace if available.", "If the error object is nil, the transfer was completed succesfully."],
          []),
        ""
        )
      ]

      return methods;
  }


  public getSGQRConnectEdgeMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration", "String?"],
        ["SGConfiguration initialized with 2 values: Cardless coordinator url and authToken(optional parameter)",
          "Bundle path or resource path of the image that needs to be displayed in scanner/camera screen. This logo has to be in the dimension 803 × 373."],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["(SGQRConnectionState, SGError?)->Void"],
        ["Callback that triggers on QR status changes"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["SGQRSessionCreationOptions","String"],
        ["Session creation options type selected (account number, or phone number etc)", "Value of the option selected"],
        []),
        ""
        )
      ]
      return methods;
  }


  public getSGQRConnectMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("static void",
        "initialize",
        "Initializes with settings required for network validation",
        new Params(["SGConfiguration"],
        ["The URL of the mobile app server."],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the QR module. Can register multiple observers",
        new Params(["SGConnectQR.SGQRStatusCallBack"],
        ["Callback that triggers on QR status change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "addObserver",
        "Registers an observer that returns the state of the user session",
        new Params(["SGSessionStatusCallBack"],
        ["Callback that triggers on session state change"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "createSession",
        "Automatically scans, connects, and then starts a session with the gaming machine.",
        new Params(["android.app.Activity","String"],
        ["Context", "User card number"],
        []),
        ""
        ),
        new MethodSummary("static void",
        "endSession",
        "Sends a command to the gaming machine to end the user's session.",
        new Params([],
        [],
        []),
        ""
        ),
        new MethodSummary("static boolean",
        "isSupported",
        "Is QR supported?",
        new Params([],
        [],
        []),
        "Returns whether or not the phone supports QR scanning capabilities"
        ),
        new MethodSummary("static void",
        "destroyConnection",
        "Needs to call activity's onDestroy in order to do some cleanup",
        new Params(["int","int", "android.content.Intent"],
        ["Request code", "result code", "intent data"],
        []),
        ""
        )
      ]
      return methods;
  }

  public getSGQRStatusCallBackMethods():MethodSummary[]{
    var methods:MethodSummary[] = [
        new MethodSummary("void",
        "onUpdate",
        "Fires when QR changes state",
        new Params(
          ["SGQRConnectionState"],
          ["The current QR state"],
          []),
        ""
        ),
        new MethodSummary("void",
        "onError",
        "Fires if there is a QR related error.",
        new Params(["SGError"],
        ["Object that holds the error type, a localized description, and stack trace if available."],
        []),
        ""
        )
      ]

      return methods;
}

}
